import React from 'react';
import { Spinner } from 'reactstrap';
import './overlay.scss';

export const Loading = () => (
    <div className="overlay">
        <Spinner color="light">{""}</Spinner>
    </div>
);
